import Header from "../../../components/layouts/header";
import Sidebar from "../../../components/layouts/sidebar";
import { useEffect, useState } from "react";
import { getComparator, stableSort } from "../../../utility/helpers/common";
import {
	IconButton,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	TableSortLabel,
	TextField,
	Tooltip,
} from "@mui/material";
import { ISearchCriteria } from "../../../utility/interfaces";
import { toast } from "react-toastify";
import { getAllCommonRecords } from "../../../services";
import { HttpStatusCodes } from "../../../utility/enums";
import { Add, Refresh } from "@mui/icons-material";
import { APIRoutes } from "../../../utility/app-routes";
import { CustomPagination, NoRecordFound } from "../../../components";
import { AddUpdateCommonRecord } from "../../../components/common/common-master-record/add-update-common-dialog";
import { MasterCommonRecordRow } from "../../../components/common/common-master-record/master-common-record-row";
import { RoleRecordRow } from "../../../components/common/common-master-record/role-record-row";
import { tableRowPerPage } from "../../../utility/constant";

const Role: React.FC = () => {
	const [isAddNewRecordOpen, setIsAddNewRecordOpen] = useState(false);
	const [searchCriteria, setSearchCriteria] = useState<ISearchCriteria>({
		rowPerPage: tableRowPerPage,
		pageNumber: 1,
		sortBy: "name",
		sortDirection: "asc",
		text: "",
	});
	const [bindPageData, setBindPageData] = useState<any>([]);
	const [tableData, setTableData] = useState<any>([]);

	const handleOnChangeSearchCriteria = (value: any, name: string) => {
		setSearchCriteria({ ...searchCriteria, [name]: value });
	};
	const handleOnChangeSorting = (sortBy: string) => {
		setSearchCriteria({
			...searchCriteria,
			sortDirection: searchCriteria.sortDirection === "asc" ? "desc" : "asc",
			sortBy,
		});
	};
	const getAllRecords = async () => {
		const { data } = await getAllCommonRecords(APIRoutes.getAllRoles);
		if (data && data.status === HttpStatusCodes.Ok) {
			setBindPageData(data.response);
		} else if (data && data.status === HttpStatusCodes.NotFound) {
			setBindPageData([]);
		} else {
			setBindPageData([]);
			toast.error(data.message);
		}
	};
	const handleOnChangeSearchText = (value: any) => {
		setSearchCriteria({
			...searchCriteria,
			text: value,
			pageNumber: 1,
			sortBy: "name",
			sortDirection: "asc",
		});
	};
	// useEffects
	useEffect(() => {
		getAllRecords();
	}, []);
	useEffect(() => {
		let filteredData: any = [];
		stableSort(
			searchCriteria.text.length > 0
				? bindPageData.filter((data: any) =>
						data.name
							?.toLowerCase()
							.includes(searchCriteria.text?.toLowerCase())
				  )
				: bindPageData,
			getComparator(searchCriteria.sortDirection, searchCriteria.sortBy)
		).map((data) => {
			filteredData.push({
				id: +data.id,
				isActive: data.isActive ? true : false,
				name: data.name,
			});
		});
		filteredData = filteredData.slice(
			(searchCriteria.pageNumber - 1) * searchCriteria.rowPerPage,
			(searchCriteria.pageNumber - 1) * searchCriteria.rowPerPage +
				searchCriteria.rowPerPage
		);
		setTableData(filteredData);
	}, [bindPageData, searchCriteria]);

	return (
		<div className="page-inner">
			<>
				<div className="page-heading-wrapper">
					<h4 className="page-heading">Roles</h4>
					<Tooltip title="Refresh">
						<IconButton
							aria-label="refresh"
							color="primary"
							className="primary-icon"
							onClick={getAllRecords}
						>
							<Refresh />
						</IconButton>
					</Tooltip>
					<Tooltip title="Add Role">
						<IconButton
							aria-label="add"
							color="primary"
							className="primary-icon"
							onClick={() => setIsAddNewRecordOpen(true)}
						>
							<Add />
						</IconButton>
					</Tooltip>
				</div>
				<div className="white-paper">
					<div className="table-heading-block">
						<TextField
							value={searchCriteria.text}
							autoFocus
							onChange={(e) => {
								handleOnChangeSearchText(e.target.value);
							}}
							label="Search"
							variant="outlined"
						/>
					</div>
					<div className="table-negative-space">
						<TableContainer>
							<Table aria-label="simple table">
								<TableHead>
									<TableRow>
										<TableCell sortDirection={searchCriteria.sortDirection}>
											<TableSortLabel
												active={searchCriteria.sortBy === "name"}
												direction={searchCriteria.sortDirection}
												onClick={() => handleOnChangeSorting("name")}
											>
												Name
											</TableSortLabel>
										</TableCell>
										<TableCell>
											<TableSortLabel
												active={searchCriteria.sortBy === "isActive"}
												direction={searchCriteria.sortDirection}
												onClick={() => handleOnChangeSorting("isActive")}
											>
												Status
											</TableSortLabel>
										</TableCell>
										<TableCell>Manage</TableCell>
										<TableCell className="action-col" align="center">
											Action
										</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{tableData.map((data: any) => {
										return (
											<RoleRecordRow
												addUpdateApiUrl={APIRoutes.addUpdateRole}
												deleteApiUrl={APIRoutes.deleteRole}
												title={"Role"}
												getAllRecords={getAllRecords}
												data={data}
											/>
										);
									})}
								</TableBody>
								{tableData?.length <= 0 && <NoRecordFound />}
							</Table>
						</TableContainer>
					</div>
					<CustomPagination
						handleOnChangeSearchCriteria={handleOnChangeSearchCriteria}
						pageNumber={searchCriteria.pageNumber}
						rowPerPage={searchCriteria.rowPerPage}
						totalRecords={bindPageData?.length}
					/>
				</div>
				<>
					{/* Add record */}
					<AddUpdateCommonRecord
						dialogOpen={isAddNewRecordOpen}
						handleOnClickClose={() => setIsAddNewRecordOpen(false)}
						dialogTitle={"Role"}
						getAllRecords={getAllRecords}
						apiPath={APIRoutes.addUpdateRole}
						data={undefined}
					/>
				</>
			</>
		</div>
	);
};
export default Role;
